import { IRiderLocationObject, IRiderLocationState, IRiderState, IRiderActivityLocationObject } from '../../../types'
import UIMessages from '../../../utils/ui-messages'
import { IRiderAction } from '../../actions/riders'
import { IRiderLocationAction } from '../../actions/rider-locations'
import { filterRiderLocations } from '../../selectors'
import * as constants from '../../constants'

const initialState: IRiderLocationState = {
  isFetching: false,
  items: {},
  metadata: {
    fetching: false,
    fetchingError: '',
    fetchingSuccess: '',
    processing: false,
    processingSuccess: '',
    processingError: ''
  },
  query: '',
  lastUpdated: 0
}

//possibly have only 1 type of action?
export function riderLocations(
  state: IRiderLocationState,
  action: IRiderLocationAction | IRiderAction
): IRiderLocationState {
  if (typeof state === 'undefined') {
    return initialState
  }
  const metadata = {
    fetching: false,
    fetchingError: '',
    fetchingSuccess: '',
    processing: false,
    processingError: '',
    processingSuccess: ''
  }
  switch (action.type) {
    case constants.RIDER_LOCATION_LIST_REQUEST: {
      return Object.assign({}, state, {
        isFetching: true
      })
    }
    case constants.RIDER_LOCATION_LIST_SUCCESS: {
      return Object.assign({}, state, {
        isFetching: false,
        lastUpdated: Date.now(),
        items: { ...action.payload.locationList }
      })
    }
    case constants.RIDER_LOCATION_LIST_FAILURE: {
      return Object.assign({}, state, {
        isFetching: false
      })
    }

    case constants.RIDER_CREATE_LOCATION_REQUEST: {
      metadata.processing = true
      return Object.assign({}, state, { metadata })
    }

    case constants.RIDER_CREATE_LOCATION_SUCCESS: {
      const location = action.payload
      const items = Object.assign({}, state.items)
      items[location.id!] = Object.assign({}, items[location.id!], location)
      metadata.processingSuccess = UIMessages.rider.location.successfullyUpdated
      return Object.assign({}, state, { items, metadata })
    }

    case constants.RIDERS_UPDATE_LOCATIONS_REQUEST: {
      metadata.processing = true
      return Object.assign({}, state, { metadata })
    }

    case constants.RIDERS_UPDATE_LOCATIONS_SUCCESS: {
      const { locations } = action.payload
      const items = Object.assign({}, state.items)
      locations.map((l: IRiderLocationObject) => (items[l.id!] = l))
      metadata.processingSuccess = UIMessages.rider.location.successfullyUpdated
      return Object.assign({}, state, { items, metadata })
    }

    case constants.RIDER_REMOVE_LOCATION_REQUEST: {
      metadata.processing = true
      return Object.assign({}, state, { metadata })
    }

    case constants.RIDER_REMOVE_LOCATION_SUCCESS: {
      const { id } = action.payload
      delete state.items[id]
      metadata.processing = true

      return Object.assign({}, state, {
        lastUpdated: Date.now()
      })
    }

    case constants.SET_RIDER_LOCATION_QUERY: {
      return Object.assign({}, state, {
        query: action.payload
      })
    }
  }
  return state
}

export const getLocationListByRiderId = (
  riders: IRiderState,
  riderLocations: IRiderLocationState,
  riderId: string
): IRiderLocationObject[] => {
  const rider = riders.items[riderId]
  if (!rider || !rider.locations) {
    return []
  }

  const items = Object.assign({}, riderLocations.items)
  return Object.keys(items)
    .filter((key: string) => rider.locations.includes(key))
    .map((key: string) => items[key])
}

export const getLocationActivityListByRiderId = (
  riders: IRiderState,
  riderId: string
): IRiderActivityLocationObject[] => {
  const rider = riders.items[riderId]
  if (!rider || !rider.locationActivity) {
    return []
  }
  return rider.locationActivity
}

export const getRiderLocationsList = (state: IRiderLocationState) => {
  if (!state.items) {
    return []
  }
  return Object.values(state.items)
}



// WEBPACK FOOTER //
// ./src/state/reducers/rider-location/index.ts